import { render, staticRenderFns } from "./ModalSelecionaAno.vue?vue&type=template&id=d33074e6&"
import script from "./ModalSelecionaAno.vue?vue&type=script&lang=js&"
export * from "./ModalSelecionaAno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports